import { FC, memo } from 'react';

import { BadgeList } from '../../../BadgeList/BadgeList';
import { Block } from '../../Block';
import { BadgesProps } from './types/BadgesProps';

const BadgesComponent: FC<BadgesProps> = ({ block }) => (
  <BadgeList>
    {block.badges.map((badgeBlock) => (
      <Block key={badgeBlock.id} block={badgeBlock} />
    ))}
  </BadgeList>
);

export const Badges = memo(BadgesComponent);
